import { useState, Fragment } from "react";
import questionList from "./questionList";
import QuestionPill from "./QuestionPill";

export default function QuestionsAndAnswers() {
  const [expandedPill, setExpandedPill] = useState(-1);

  return (
    <div className="flex flex-col items-center p-12 space-y-6">
      {questionList.map((item, index) => (
        <Fragment key={item.question}>
          <QuestionPill
            item={item}
            index={index}
            expandedPill={expandedPill}
            setPillAsExpanded={setExpandedPill}
          />
        </Fragment>
      ))}
    </div>
  );
}
